import { Component, Prop, h, Host } from "@stencil/core";

@Component({
    tag: "ux-w-empty",
    styleUrl: "empty.scss",
    shadow: false
})
export class Empty {
    /** icon name - must exist in the ux-icon list of available icons */
    @Prop() icon: string = "";
    /** optional Link for the button */
    @Prop() link?: string = "";
    /** Text for Link Button */
    @Prop() linkText?: string = "";

    render() {
        const baseClass = "ux-w-empty";
        const { icon, link, linkText } = this;
        const hasLink = link !== "" && linkText !== "";
        return (
            <Host class={baseClass}>
                <ux-icon class={`${baseClass}__background`} name={icon} />
                <div class={`${baseClass}__inner`}>
                    <ux-icon class={`${baseClass}__icon`} name={icon} />
                    <div class={`${baseClass}__text`}>
                        <div class={`${baseClass}__text-content`}>
                            <slot />
                        </div>
                        {hasLink && (
                            <ux-button href={link} class={`${baseClass}__link`}>
                                {linkText}
                            </ux-button>
                        )}
                    </div>
                </div>
            </Host>
        );
    }
}
